
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { formatCurrency } from '@/utils/numberFormats';
import PlanCapabilities from './PlanCapabilities.vue';

interface SoftwarePlanData {
  id: number;
  price: number;
  users: number;
  interactionz: number;
  priceForExceededUsers: number
  priceForExceededInteratcionz: number;
}

interface ChannelPlanData {
  id: number;
  price: number;
  sms: number;
  whatsapp: number;
  email: number;
}

interface CardData {
  currency: string;
  softwarePlan: SoftwarePlanData;
  channelPlan: ChannelPlanData;
}

interface DefaultSelected {
  plan: SoftwarePlanData;
  channel: ChannelPlanData;
}

@Component({
  components: {
    PlanCapabilities,
  },
})
export default class PlanSummaryCard extends Vue {
  @Prop({
    required: false,
    default: () => ({}),
    type: Object,
  }) private cardData!: CardData;

  @Prop({
    required: true,
    default: () => false,
    type: Boolean,
  }) private isButtonLoading!: boolean;

  @Prop({
    required: false,
    default: () => ({}),
    type: Object,
  }) private defaultSelected!: DefaultSelected;

  formatCurrency = formatCurrency;

  handleSubmitPlanChange() {
    this.$emit('onSubmitPlanChange');
  }

  get getIsEnterprise() {
    return this.cardData?.softwarePlan?.id === 5;
  }

  get hasPreSelectedPlan() {
    return !!this.defaultSelected.plan?.id && !!this.defaultSelected.channel?.id;
  }

  get isSamePlanSelected() {
    return this.cardData.softwarePlan?.id === this.defaultSelected.plan?.id && this.cardData.channelPlan?.id === this.defaultSelected.channel?.id;
  }

  get isButtonDisabled() {
    return this.hasPreSelectedPlan && this.isSamePlanSelected;
  }

  get canSeeBadge() {
    if (!this.hasPreSelectedPlan) {
      return false;
    }

    if (this.isSamePlanSelected) {
      return true;
    }

    return false;
  }
}
